// @flow

import type { BusinessLabelSettings, BusinessLabelSettingsItem } from './types';
import { getBusinessLabel } from '../routes';
import type { State as RouterState } from '../router/types';
import type { State as RoutesState } from '../routes/types';

type GlobalState = {
  businessLabelSettings: BusinessLabelSettings,
  router: RouterState,
  routes: RoutesState,
};

const getBusinessLabelSettings = (state: GlobalState): BusinessLabelSettings => {
  const { businessLabelSettings } = state;
  if (!businessLabelSettings) {
    throw new Error('Missing businessLabelSettings store.');
  }
  return businessLabelSettings;
};

const getActiveBusinessLabelSettings = (
  state: GlobalState,
  label?: string,
): BusinessLabelSettingsItem | null => {
  const businessLabel = label || getBusinessLabel(state);
  const settings = getBusinessLabelSettings(state);
  if (!settings[businessLabel]) {
    return null;
  }
  return settings[businessLabel];
};

export const getHeaderMenuKey = (state: GlobalState): string => {
  const settings = getActiveBusinessLabelSettings(state);
  if (settings === null) {
    return '';
  }
  return settings.header_menu;
};

export const getFooterMenuKey = (state: GlobalState): string => {
  const settings = getActiveBusinessLabelSettings(state);
  if (settings === null) {
    return '';
  }
  return settings.footer_menu;
};

export const getBusinessLabelById = (
  state: GlobalState,
  key: string,
): BusinessLabelSettingsItem => {
  const settings = getBusinessLabelSettings(state);
  if (!settings[key]) {
    throw new Error(`Requested businessLabelSettings for ${key} not available.`);
  }
  return settings[key];
};

export default getBusinessLabelSettings;
